
	/**
	 * @description
	 *  Modelo de un ítem en una nota de CyR o NC, sobre un pedido.
	 *
	 * @see gigot-backend/Models/Orders/OrderEvent.cs
	 */

export class OrderEventItems {

	public id: number;
	public orderEventId: number;
	public orderItemId: number;
	public quantity: number;
	public received: boolean;

	/**
	 * @description
	 *	Construye un ítem de una nota con una semántica vacía. Nótese que no
	 *	es lo mismo que construir un ítem con valores por defecto. Las reglas
	 *	generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un ítem en una nota de CyR/NC vacío.
	 */
	public static empty(): OrderEventItems {
		const orderEventItems: OrderEventItems = new OrderEventItems();
		orderEventItems.id = undefined;
		orderEventItems.orderEventId = undefined;
		orderEventItems.orderItemId = undefined;
		orderEventItems.quantity = undefined;
		orderEventItems.received = false;
		return orderEventItems;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicOrderEventItems
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicOrderEventItems: OrderEventItems): OrderEventItems {
		if (!anemicOrderEventItems) return undefined;
		const orderEventItems: OrderEventItems = OrderEventItems.empty();
		orderEventItems.id = anemicOrderEventItems.id;
		orderEventItems.orderEventId = anemicOrderEventItems.orderEventId;
		orderEventItems.orderItemId = anemicOrderEventItems.orderItemId;
		orderEventItems.quantity = anemicOrderEventItems.quantity;
		orderEventItems.received = anemicOrderEventItems.received;
		return orderEventItems;
	}
}
